import 'what-input';
import $ from 'jquery';
import Swiper from './lib/swiper.js';

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used`import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.$ = $;
window.Swiper = Swiper;

import './lib/foundation-explicit-pieces';

require('./lib/jquery.ihavecookies');

require('./lib/listeners');

if (document.getElementById('countdown-conf')) {
  require('./lib/countdown');
}
$(document).foundation();

if (document.getElementById('refunds')) {
  require('./lib/refunds');
}

// Close offCanvas when click on item menu
const offCanvas = document.getElementsByClassName('off-canvas');
for (let i = 0; i < offCanvas.length; i++) {
  offCanvas[i].addEventListener('click', (e) => $('.off-canvas').foundation('close'));
}
